import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

export type SimulatorPack = {
    name: string;
    content: string;
    nbPlan: number;
    icon: IconName;
    isActive: boolean;
    isDefault: boolean;
};

export type ImpactsSimulation = {
    currentCommercialOrders?: CurrentCommercialOrder[];
    contracts: Contract[];
    messages?: Message[];
    proposed?: Proposed[];
    summaryPU: SummaryPU;
};

export type CurrentCommercialOrder = {
    orderId: string;
    mainOffers: ApplicableOp[];
};

export type ApplicableOp = {
    advantages?: Advantage[];
    compatibleWithDiscounts?: Discount[];
    conditionForDiscounts?: Discount[];
    endOfCommitmentDate?: Date;
    commitmentDuration?: number;
    convergenceRange?: string;
    offerId: string;
    commercialLabel: string;
    marketLine: string;
    convergentMarketLine: string;
    amountPaid: number;
    amountPaidAfterSimulation: number;
    convergenceRangeLevel?: string;
    options?: Option[];
    priceIncludingTax: number;
};

export type Advantage = {
    action: ACTION_TYPES;
    endOfValidityDate?: Date;
    duration?: number;
    offerId: string;
    label: string;
    familyPack: boolean;
    discountIncludingTax: number;
    vatRate?: number;
    durationUnit?: string;
};

export type Discount = {
    type: string;
};

export type Option = {
    label: string;
    amountIncludingTax: number;
    vatRate: number;
};

export type Contract = {
    id: string;
    msisdn?: string;
    voipNumber?: string;
    secondaryOffers?: SecondaryOffer[];
    applicableOp: ApplicableOp;
};

export type SecondaryOffer = {
    action: string;
    offerId: string;
    commercialLabel: string;
    priceExcludingTax: number;
    priceIncludingTax: number;
    vatRate: number;
    incompatibleType?: boolean;
    offerType: string;
};

export type Message = {
    code: string;
    label: string;
    parameters: Parameter[];
};

export type Parameter = {
    code: string;
    value: string;
};

export type Proposed = {
    secondaryOffers: SecondaryOffer[];
    applicableOp: ApplicableOp;
    journey: string;
};

export type SummaryPU = {
    currentPlan: CurrentPlan;
    simulationImpact: CurrentPlan;
};

export type CurrentPlan = {
    mainOffers: SimulatorOffers;
    toutatisDiscounts: SimulatorOffers;
};

export type SimulatorOffers = {
    globalAmount: number;
    globalAmountCurrentOrders: number;
    globalAmountHeldOffers: number;
    globalAmountProposed?: number;
};

export enum ACTION_TYPES {
    SOUSCRIPTION = 'SOUSCRIPTION',
    RESILIATION = 'RESILIATION',
    CONSERVATION = 'CONSERVATION',
    MODIFICATION = 'MODIFICATION',
}
